import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=bcf16f3c&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=ts"
export * from "./productManage.vue?vue&type=script&lang=ts"
import style0 from "./productManage.vue?vue&type=style&index=0&id=bcf16f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf16f3c",
  null
  
)

export default component.exports